import { useEffect } from 'react';

import { usePerformanceActions } from 'src/store';

export const useQueryChannelAccounts = (channel) => {
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    performanceActions.queryAdAccounts(channel);
  }, [performanceActions, channel]);
};
